import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/loan-refinance-calculator',
  component: () => import('../../routes/LoanRefinanceCalculator.svelte'),
  card: {
    id: 'loan-refinance-calculator',
    title: 'Loan Refinance Calculator',
    description: 'Compare your current loan with refinance options to find monthly savings and break-even points.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/loan-refinance-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Loan Refinance Calculator – Compare Refinance Rates & Savings',
    description:
      'Free loan refinance calculator to compare your current loan against new rates. Calculate monthly savings, break-even points, and total interest savings. Determine if refinancing makes sense.',
  },
};

export default meta;
